import styled from 'styled-components';
import { Typ30 } from 'dc/Typ';
import Load02 from 'dc/Load02';
import Btn33 from 'dc/Btn33';

export const HabitsPlaceholderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
`;

export const HabitsPlaceholderText = styled(Typ30)`
  width: 280px;
  display: block;
  text-align: center;
  color: #546e7a;
`;

export const HabitLogLoader = styled(Load02)`
  margin: 3px;
`;

export const LogAllButton = styled(Btn33)``;
